import {
  arrayOf, func, node, objectOf, oneOfType, string
} from 'prop-types';
import React, { useEffect } from 'react';
import useValidation from '../useValidation';
import connectSectionToContext from './connectSectionToContext';

const FormSection = ({
  children, errors, initialErrors, name,
  registerSelfValidatingChild, unregisterSelfValidatingChild, ...rest
}) => {
  const [ChildProvider, childContext, { validate }] = useValidation({
    ...rest,
    initialErrors: errors || initialErrors,
    name
  });

  useEffect(() => {
    registerSelfValidatingChild(name, validate);

    return () => unregisterSelfValidatingChild(name);
  }, [
    registerSelfValidatingChild,
    unregisterSelfValidatingChild,
    name,
    validate
  ]);

  return (
    <ChildProvider value={childContext}>
      {typeof children === 'function' ? children({
        ...rest,
        ...childContext
      }) : children}
    </ChildProvider>
  );
};

FormSection.propTypes = {

  /** The children of the component, the argument to the function
   *  is the props and the FormContext value for the section */
  children: oneOfType([func, node]).isRequired,

  /** data passed down from the parent context */
  data: objectOf({}),

  /** errors passed down from the parent context */
  errors: objectOf({}),

  /** The initial form data for the section */
  initialData: objectOf({}),

  /** Any validation errors that exist within the section's data */
  initialErrors: objectOf(arrayOf(string)),

  /** The key in the parent data that the resulting data objects should exist at */
  name: string.isRequired,

  /** function passed down from the parent context */
  onChange: func.isRequired,

  /** function passed down from the parent context */
  registerSelfValidatingChild: func.isRequired,

  /** function passed down from the parent context */
  unregisterSelfValidatingChild: func.isRequired,
  /** Validator specs keyed by the names of the child fields */
  validators: objectOf({})
};

FormSection.defaultProps = {
  data: {},
  errors: undefined,
  initialData: undefined,
  initialErrors: undefined,
  validators: undefined
};

export default connectSectionToContext(FormSection);
